import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { redirectAfterCompanyAuth } from "../utils/onboardingRedirect";

const API = process.env.REACT_APP_API_URL || "http://localhost:8000";

export default function AuthCallback() {
    const navigate = useNavigate();
    const [params] = useSearchParams();
    const { loginWithToken } = useAuth();
    const [authError, setAuthError] = useState("");

    useEffect(() => {
        async function handle() {
            const token = params.get("token");

            if (!token) {
                navigate("/login", { replace: true });
                return;
            }

            loginWithToken(token);

            try {
                const res = await fetch(`${API}/api/auth/me`, {
                    headers: { Authorization: `Bearer ${token}` },
                });

                if (!res.ok) {
                    setAuthError("We couldn't verify your session. Please log in again.");
                    return;
                }

                const user = await res.json();

                if (user.role === "company") {
                    await redirectAfterCompanyAuth(token, navigate);
                    return;
                }

                if (user.role === "engineer") {
                    if (user.profile && !user.profile.linkedin_url && !user.profile.github_url && !user.profile.desired_role) {
                        navigate("/complete-profile", { replace: true });
                    } else {
                        navigate("/engineer/dashboard", { replace: true });
                    }
                    return;
                }

                navigate("/", { replace: true });
            } catch {
                setAuthError("Authentication failed. Please try again.");
            }
        }
        handle();
    }, [params, loginWithToken, navigate]);

    if (authError) {
        return (
            <div className="containerX pt-24 text-center">
                <div className="inline-block bg-red-50 border border-red-200 text-red-700 rounded-2xl px-8 py-6 max-w-sm">
                    <div className="font-semibold mb-2">Authentication failed</div>
                    <div className="text-sm mb-4">{authError}</div>
                    <button
                        onClick={() => navigate("/login")}
                        className="btn btnPrimary justify-center mx-auto text-sm"
                    >
                        Back to login
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div className="containerX pt-24 text-center">
            <div className="text-slate-400">Authenticating...</div>
        </div>
    );
}
